/**
 * ÂMEDORÉE — gallery progress line (COS-style product page)
 * Sizes the bar to the share of images in view and moves it as the gallery
 * scrolls. Listens at document level (capture), so it keeps working after the
 * theme re-renders the gallery on a variant change.
 */
(function () {
  'use strict';

  if (window.__amdGalleryProgress) return;
  window.__amdGalleryProgress = true;

  // The progress line is added here rather than in the gallery markup, so the
  // theme's own gallery file stays untouched.
  function ensureTrack(carousel) {
    var wrap = carousel.parentElement;
    if (!wrap || !carousel.closest('.shopify-section--main-product')) return null;

    var track = wrap.querySelector(':scope > .amd-gallery-progress');
    if (!track) {
      track = document.createElement('div');
      track.className = 'amd-gallery-progress';
      track.setAttribute('aria-hidden', 'true');
      track.innerHTML = '<span class="amd-gallery-progress__bar"></span>';
      wrap.appendChild(track);
    }
    return track;
  }

  function update(carousel) {
    var track = ensureTrack(carousel);
    var bar = track && track.querySelector('.amd-gallery-progress__bar');
    if (!bar) return;

    var total = carousel.scrollWidth;
    var view = carousel.clientWidth;
    if (!total || !view) return;

    var visible = Math.min(1, view / total);
    var max = total - view;
    var position = max > 0 ? Math.abs(carousel.scrollLeft) / max : 0;

    track.hidden = visible >= 0.999;
    bar.style.width = visible * 100 + '%';
    bar.style.transform = 'translateX(' + position * (1 / visible - 1) * 100 + '%)';
  }

  function updateAll() {
    document.querySelectorAll('.product-gallery__carousel').forEach(update);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target instanceof Element && target.classList.contains('product-gallery__carousel')) {
        update(target);
      }
    },
    true
  );

  window.addEventListener('resize', updateAll);
  window.addEventListener('load', updateAll);
  document.addEventListener('variant:change', function () {
    window.setTimeout(updateAll, 50);
  });

  updateAll();
})();
